export function isMacOS() {
  if (navigator.appVersion.indexOf("Mac")!=-1)
    return true
  return false
}